import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";
import { BackgroundMusic } from "./BackGroundSong";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const url = [
    "https://www.facebook.com/elliot.anderson.79230/",
    "https://github.com/Brandzess123",
    "https://www.linkedin.com/in/hieu-dang-3889901a4/",
  ];

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <BackgroundMusic />
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={activeLink === "home" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={activeLink === "skills" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("skills")}
              >
                Skills
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={activeLink === "projects" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("projects")}
              >
                Projects
              </Nav.Link>
              <Nav.Link
                href="#arcane-lab"
                className={activeLink === "arcane" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("arcane")}
              >
                Arcane
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href={url[0]} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg"
                    alt="Facebook"
                    style={{ width: "15px" }}
                  />
                </a>

                <a href={url[1]} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg"
                    alt="GitHub"
                    style={{ width: "15px" }}
                  />
                </a>

                <a href={url[2]} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg"
                    alt="LinkedIn"
                    style={{ width: "15px" }}
                  />
                </a>
              </div>
              <HashLink to="#arcane-lab">
                <button className="vvd">
                  <span>Enter The Undercity</span>
                </button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
